import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from "immutable";
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";

import TextInputField from '../../infra/components/formInput/CustomTextInput'
import ActionAdd from '../../store/action/Previlage/Add'
import ActionEdit from '../../store/action/Previlage/Edit'
import { IsEdit, IsCreate, IsView } from '../../store/constants'
import CheckBoxInputField from "../../infra/components/formInput/CustomCheckBoxInput";
import ActionFindByGroupId from '../../store/action/Previlage/FindByGroupId'
import { PrevilageId } from "../../helper/HelperAuth";


class Form extends Component {

  constructor(props) {
    super(props);
    this.state = {
      form: fromJS({
        'privilege-id': '',
        'privilege-name': '',
        'is-admin':false
      }),
      isadmin:"hide",
      loadded: false,
      disabled: false,
      errors: fromJS({}),
      error: '',
      checkedadmin: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  handleChange(field, value) {
    var formVal = this.state.form;
    formVal = formVal.set(field, value);
    this.setState({ form: formVal })
  }
  async handleSubmit(dispatch) {

    const form = this.state.form;
    if (form.get('privilege-name') === '') {
      this.setState({ error: "Name cannot be empty!" });
    } else {

      switch (this.props.actionType) {
        case IsCreate:
          await this.SubmitNewData();
          break;
        case IsEdit:
          await this.SubmitEditData();
          break;
        default:
        // code block
      }

    }
  }

  async SubmitNewData() {
    const form = this.state.form;
    var data =
    {
      'data':
      {
        'privilege-name': form.get('privilege-name'),
        'is-admin': form.get('is-admin')
      }
    };

    var response = await this.props.actionAdd(data);
    if (response.ok) {
      toast.success('Save Success!', toast.POSITION.TOP_RIGHT);
      this.props.handleCancelForm(true);
    } else {
      toast.error('Save Failed', toast.POSITION.TOP_RIGHT);
    }
  }

  async SubmitEditData() {
    const form = this.state.form;
    var data =
    {
      'data': {
        'privilege-id': form.get('privilege-id'),
        'privilege-name': form.get('privilege-name'),
        'is-admin':form.get('is-admin')
      }
    };

    var response = await this.props.actionEdit(data);
    if (response.ok) {
      toast.success('Edit Success!', toast.POSITION.TOP_RIGHT);
      this.props.handleCancelForm(true);
    } else {
      toast.error('Edit Failed', toast.POSITION.TOP_RIGHT);
    }
  }

  handleChangeChecker(field, value) {
    var formVal = this.state.form

    if (value == true) {
      formVal = formVal.set('is-admin', true)
    } else {
      formVal = formVal.set('is-admin', false)
    }
    this.setState({
      form: formVal,
      checkedadmin: value
    })
  }

  handleCancel() {
    this.props.handleCancelForm(false);
  }

 async componentWillMount() {
    if (this.props.item != null || this.props.item !== undefined) {
      var isAdmin = await this.props.actionFindByGroupId()
      //debugger
      if(PrevilageId == 1 || isAdmin == true){
        this.setState({isadmin:""})
      }else{
        this.setState({isadmin:"hide"})
      }
      if ((this.props.actionType === IsView || this.props.actionType === IsEdit) && !this.state.loadded) {
        var isadmins = this.props.item.get('is-admin') == "0" ? false:true
        this.setState({
          form: fromJS({
            'privilege-id': this.props.item.get('privilege-id'),
            'privilege-name': this.props.item.get('privilege-name'),
            'is-admin':isadmins
          }),
          checkedadmin:isadmins,
          loadded: true,
          disabled: (this.props.actionType === IsView),
        })
      }
    }
  }

  render() {
    const { form, errors, disabled, checkedadmin } = this.state;
    return (
      <div className="card no-margin-bottom">
        <div className="body">
          <div className="row no-margin-bottom">
            <span className="col-sm-2">Name</span>
            <div className="col-sm-10">
              <TextInputField className="form-control"
                field={'privilege-name'}
                value={form.get('privilege-name')}
                onChange={(field, value) => this.handleChange(field, value)}
                placeholder="name"
                disabled={disabled}
                hasError={errors.has('name')}
              />
            </div>
          </div>
          <div className={`row no-margin-bottom ${this.state.isadmin}`}>
            <span className={`col-sm-2`}>Previlage Admin</span>
            <div className={`col-sm-2`}>
              <CheckBoxInputField className="form-control"
                field={"is-admin"}
                checked={checkedadmin}
                onChange={(field, value) => this.handleChangeChecker(field, value)}
              />
            </div>
          </div>
          <div className="row no-margin-bottom">
            <span className="col-sm-2"></span>
            <div className="col-sm-10">
              <button type="button"
                className="btn btn-wide btn-danger"
                value="Cancel"
                onClick={this.handleCancel}>
                Cancel
              </button>
              <button type="button"
                className="btn btn-wide btn-success"
                onClick={this.handleSubmit}>
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


export default connect(
  (state) => {
    return {
      Users: state.user.users,
    }
  },
  dispatch => bindActionCreators({
    actionAdd: ActionAdd,
    actionEdit: ActionEdit,
    actionFindByGroupId:ActionFindByGroupId
  }, dispatch),
)(Form);